import { StoreProvider } from 'easy-peasy'
import StitchBean from './StitchBean';
import { GetStore  } from './store/data-store';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQuestionCircle, faAdd, faTrash, faPlus, faMinus, faChevronDown, faChevronUp, faChevronLeft  } from "@fortawesome/free-solid-svg-icons";
import { faBars } from '@fortawesome/free-solid-svg-icons';

library.add(faAdd, faPlus, faMinus, faChevronDown, faChevronUp, faChevronLeft );
library.add(faQuestionCircle);
library.add(faTrash, faBars);

const stitchBeanStore = GetStore();

function App() {

  return (
    <div className="App">
      <StoreProvider store={stitchBeanStore}>
        <StitchBean/>
      </StoreProvider>
    </div>
  );
}

export default App;
